import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'

import { SALES_VELOCITY_METRICS_GUIDE_ROWS } from './salesVelocityMetricsGuideContent'

export default function SalesVelocityMetricsGuideModal({ show, onHide }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      scrollable
      className="sales-velocity-metrics-guide-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title as="h4">Heatmap metrics guide</Modal.Title>
      </Modal.Header>
      <Modal.Body className="sales-velocity-metrics-guide-body">
        <Table
          responsive
          bordered
          className="sales-velocity-metrics-guide-table mb-0"
        >
          <thead>
            <tr>
              <th>Metric</th>
              <th>What it measures</th>
              <th>Use it when you want to…</th>
            </tr>
          </thead>
          <tbody>
            {SALES_VELOCITY_METRICS_GUIDE_ROWS.map((row) => (
              <tr key={row.metric}>
                <th scope="row">{row.metric}</th>
                <td>{row.measures}</td>
                <td>{row.useWhen}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )
}
